export const toSlice = (search_word: string): string[] => {
  return search_word.split(/[\u3000&\x20;]/g).slice()
}